/* eslint-disable @typescript-eslint/no-explicit-any */

import { Controller, ControllerProps, FieldValues } from 'react-hook-form';

import { Input } from '@src/components/atoms/inputs/input';
import { InputProps } from '@src/components/atoms/inputs/input/types';

type InputWrapperProps<T extends FieldValues> = InputProps &
  Pick<ControllerProps<T>, 'name' | 'control' | 'defaultValue'>;

const InputController = <T extends FieldValues>({
  name,
  control,
  defaultValue,
  ...inputProps
}: InputWrapperProps<T>) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    shouldUnregister
    render={({ field }) => <Input {...inputProps} {...field} />}
  />
);
export default InputController;
